import { FormatterService } from "@/domain/services";

export class CpfFormatter implements FormatterService {
  format(value: string): string {
    return value
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/(\d{3})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4")
      .trim();
  }
}
